import { createFileRoute } from '@tanstack/react-router';
import { CategoriesListPage } from '@/features/categories/categories-list-page.js';

export const Route = createFileRoute('/_app/categories/')({
  component: CategoriesListPage,
});
